__webpack_require__.p = "https://affiliate-jn.devlovin.com/scripts/";